import React from 'react';
import { Shield, CheckCircle } from 'lucide-react';
import { qualityPolicy, qualityTestingLab, images } from '../data/mock';

const QualitySection = ({ onRequestQuote }) => {
  return (
    <section id="quality" className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
      <div className="container">
        <div className="text-center mb-16">
          <div className="section-header mx-auto" style={{ maxWidth: '600px', textAlign: 'center' }}>
            <p className="section-label">Quality Assurance</p>
            <h2 className="section-title">Committed to Excellence</h2>
            <p className="section-description">
              Our commitment to quality is reflected in every fastener we produce, 
              backed by rigorous testing and continuous improvement.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          <div className="image-overlay-container" style={{ height: '300px' }}>
            <img 
              src={images.quality}
              alt={images.qualityAlt}
              className="img-cover"
              loading="lazy"
            />
            <div className="image-overlay" />
          </div>
          <div className="lg:col-span-2">
            <div className="quality-grid" style={{ gap: '40px' }}>
              <div>
                <h3 className="heading-3 mb-6 flex items-center gap-3">
                  <Shield size={22} style={{ color: 'var(--accent-teal)' }} />
                  Quality Policy
                </h3>
                <ul className="quality-policy-list">
                  {qualityPolicy.map((point, index) => (
                    <li key={index} className="quality-policy-item">
                      {point}
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className="heading-3 mb-6 flex items-center gap-3">
                  <CheckCircle size={22} style={{ color: 'var(--accent-teal)' }} />
                  Testing Laboratory
                </h3>
                <div className="testing-lab-grid">
                  {qualityTestingLab.map((item, index) => (
                    <div key={index} className="testing-lab-item">
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QualitySection;
